import { request } from '@/utils/request'
const DeviceManageService = {
  state: {},

  mutations: {},

  actions: {
    // 设备分页
    GetAllEquipment({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentInfo/GetAllEquipment', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存设备
    SaveEquipment({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentInfo/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备
    DeleteEquipment({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentInfo/DeleteByObjectID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetEquipmentListByStationID({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentInfo/GetEquipmentListByStationID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default DeviceManageService
